import { rem } from 'polished';
import * as React from 'react';
import { __ } from 'react-i18n';
import styled, { withTheme } from 'styled-components';
import { ZemplinLoaderWrapper } from '../../..';
import { getFinishedOrderInfo } from '../../../utilities/selectors';
import {
  FlexCol,
  FlexColCenter,
  FlexRow,
} from '../../Defaults/Flexbox/Flexbox';
import { TextP } from '../../Defaults/Text';
import { ButtonLink } from '../General/Button';

interface Props {
  theme: any;
  order: any;
  isFetching: boolean;
  onRedirect: (url: string) => void;
  redirectUrl: string;
  error?: string;
}

function ErrorFinishedOrder({
  theme,
  order,
  isFetching,
  onRedirect,
  redirectUrl,
  error,
}: Props) {
  const { orderNr } = getFinishedOrderInfo(order);

  return (
    <Wrapper>
      {isFetching ? (
        <ZemplinLoaderWrapper />
      ) : (
        <>
          <LeftWrapper>
            <Title>{__('Chybná platba')}</Title>
            <OrderNr>Objednávka č. {orderNr}</OrderNr>
            <SmallText>
              {__(
                'Počas spracovania platby došlo k chybe. Kontaktujte vlastníka e-shopu,\nalebo skúste platbu potvrdiť znova',
              )}
            </SmallText>
            {error ? (
              <ErrorWrapper>
                <ErrorSmallText>
                  {__('Pri platbe sa vyskytla nasledovná chyba: ')}
                </ErrorSmallText>
                <Error>{error}</Error>
              </ErrorWrapper>
            ) : null}
            {
              // tslint:disable-next-line:jsx-no-lambda
              <OrderButton onClick={() => onRedirect(redirectUrl)}>
                {__('Prejsť k platbe')}
              </OrderButton>
            }
          </LeftWrapper>
        </>
      )}
    </Wrapper>
  );
}

const Wrapper = styled(FlexRow)`
  width: 100%;
  margin: 0 auto;
  padding: ${rem(80)} 0;
  max-width: ${rem(1180)};
  justify-content: space-between;

  ${({ theme }) => theme.mediab.m810`
    flex-flow: column;
    align-items: center;
    padding: ${rem(32)} 0 ${rem(56)};
  `}
`;

const LeftWrapper = styled(FlexColCenter)`
  width: 100%;
  padding: ${rem(24)} 0;
  margin: auto;
  height: fit-content;
  max-width: ${rem(480)};

  ${({ theme }) => theme.mediab.m810`
    padding: 0;
  `}
`;

const Title = styled.h2`
  margin: ${rem(32)} 0 ${rem(24)};
  font-size: ${rem(30)};
  font-family: ${({ theme }) => theme.font.primary};
  color: ${({ theme }) => theme.color.textPrimary};
  line-height: ${rem(34)};
  font-weight: 500;

  ${({ theme }) => theme.mediab.m810`
    font-size: ${rem(24)};
    line-height: ${rem(32)};
    text-align: center;
  `}
`;

const SmallText = styled(TextP)`
  font-weight: 400;
  font-family: ${({ theme }) => theme.font.primary};
  line-height: ${rem(22)};
  font-size: ${rem(14)};
  margin-bottom: ${rem(32)};
  text-align: center;
`;

const ErrorSmallText = styled(SmallText)`
  margin-bottom: ${rem(8)};
  font-weight: 500;
`;

const Error = styled(SmallText)`
  color: red;
`;

const ErrorWrapper = styled(FlexCol)``;

const OrderNr = styled(SmallText)``;

const OrderButton = styled(ButtonLink)`
  background-color: ${({ theme }) => theme.colors.secondary};
  font-family: ${({ theme }) => theme.font.primary};
  font-size: ${rem(16)};
  padding: ${rem(8)};
  line-height: ${rem(22)};
  height: ${rem(48)};
  display: flex;
  align-items: center;
  text-decoration: none;

  max-width: ${rem(262)};
  width: 100%;
  display: flex;
  justify-content: center;
  max-height: ${rem(62)};
  transition: filter 0.2s ease;

  &:hover,
  &:focus {
    background: ${({ theme }) => theme.colors.secondaryOnHover};
    outline: none;
  }
`;

const WithTheme: any = withTheme(ErrorFinishedOrder);
export { WithTheme as ErrorFinishedOrder };
